import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus--sprite",
  "use": "plus--sprite-usage",
  "viewBox": "0 0 56 55",
  "content": "<symbol viewBox=\"0 0 56 55\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus--sprite\">\n<line y1=\"27\" x2=\"56\" y2=\"27\" stroke=\"black\" stroke-width=\"4\" />\n<line x1=\"28.4346\" y1=\"19\" x2=\"28.4346\" y2=\"7.18116e-08\" stroke=\"black\" stroke-width=\"4\" />\n<line x1=\"28.4346\" y1=\"55\" x2=\"28.4346\" y2=\"36\" stroke=\"black\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol